import React, { useState, useEffect } from "react";
import { Card, CardContent, CardActions, Button, Typography, Collapse, useTheme } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { tokens } from "../theme";
import "../markdown.css";

const MarkdownCard = ({ file, maxChars = 280 }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [content, setContent] = useState("");
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/" + file)
      .then((res) => res.text())
      .then(setContent)
      .catch(() => setContent("Could not load " + file));
  }, [file]);


  const shortContent = content.length > maxChars
    ? content.slice(0, maxChars) + "..."
    : content;

  return (
    <Card sx={{ mb: 3 }}>
      {!expanded && (
        <CardContent>
          <ReactMarkdown
            children={shortContent}
            remarkPlugins={[remarkGfm, remarkBreaks]}
            className="markdown-body"
          />
        </CardContent>
      )}
      {content.length > maxChars && (
        <CardActions>
          <Button
            size="small"
            onClick={() => setExpanded((e) => !e)}
            sx={{
              color: theme.palette.mode === 'dark' ? 'inherit' : colors.blueAccent[400]
            }}
          >
            {expanded ? "Show Less" : "Show More"}
          </Button>
        </CardActions>
      )}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {expanded && content.length > maxChars && (
          <CardContent>
            <ReactMarkdown
              children={content}
              remarkPlugins={[remarkGfm, remarkBreaks]}
              className="markdown-body"
            />
          </CardContent>
        )}
      </Collapse>
      {expanded && content.length <= maxChars && (
        <CardContent>
          <ReactMarkdown
            children={content}
            remarkPlugins={[remarkGfm, remarkBreaks]}
            className="markdown-body"
          />
        </CardContent>
      )}
    </Card>
  );
};

export default MarkdownCard;
